module.exports = [
  {
    docgroup: 'passport',
    name: 'Паспорт',
    items: [
      { doctype: 'passport_main', name: 'Разворот с фотографией' },
      { doctype: 'passport_registration', name: 'Разворот с регистрацией' },
      { doctype: 'passport_selfie', name: 'Ваше фото с паспортом' },
    ],
  },

  {
    docgroup: 'medical',
    name: 'Медицинская книжка',
    items: [
      { doctype: 'med1', name: 'Основной разворот медкнижки' },
      { doctype: 'med2', name: 'Отметки о профилактических прививках' },
      { doctype: 'med3', name: 'Заключение врача о допуске к работе по результатам медицинского обследования' },
      { doctype: 'med4', name: 'Результаты обследования на туберкулёз' },
      { doctype: 'med5', name: 'Результаты исследования на носительство возбудителей кишечных инфекционных заболеваний' },
      { doctype: 'med6', name: 'Результаты лабораторных исследований и осмотра дерматовенеролога' },
      { doctype: 'med7', name: 'Результаты исследования на гельминтозы' },
      { doctype: 'med8', name: 'Результаты исследования на носительство возбудителей дифтерии' },
      { doctype: 'med9', name: 'Профессиональная гигиеническая подготовка и аттестация' },
    ],
  },

  {
    docgroup: 'drive',
    name: 'Водительское удостоверение',
    items: [
      { doctype: 'drive_front', name: 'Лицевая сторона' },
      { doctype: 'drive_back', name: 'Обратная сторона' },
    ],
  },

  {
    docgroup: 'covidvax',
    name: 'COVID-19',
    items: [
      { doctype: 'covidvax1', name: 'Страница 1' },
      { doctype: 'covidvax2', name: 'Страница 2' },
      { doctype: 'covidvax3', name: 'Страница 3' },
      { doctype: 'covidvax4', name: 'Страница 4' },
    ],
  },
  {
    docgroup: 'additional_passport_pages',
    name: 'Дополнительные страницы паспорта',
    items: [
      { doctype: 'additional_page1', name: 'Первая дополнительная страница' },
      { doctype: 'additional_page2', name: 'Вторая дополнительная страница' },
      { doctype: 'additional_page3', name: 'Третья дополнительная страница' },
    ],
  },

  // {
  //   docgroup: 'temporary_residence',
  //   name: 'Разрешение на временное проживание',
  //   items: [
  //     { doctype: 'temporary_residence_main', name: 'Основной разворот' },
  //     { doctype: 'temporary_residence_seal', name: 'Разворот со штампом РВП' },
  //     { doctype: 'temporary_residence_selfie', name: 'Ваше фото с РВП' }
  //   ]
  // },

  // {
  //   docgroup: 'permanent_residence',
  //   name: 'Вид на жительство',
  //   items: [
  //     { doctype: 'permanent_residence_main', name: 'Основной разворот' },
  //     { doctype: 'permanent_residence_seal', name: 'Разворот со штампом ВНЖ' },
  //     { doctype: 'permanent_residence_selfie', ame: 'Ваше фото с ВНЖ' }
  //   ]
  // },

  // {
  //   docgroup: 'foreigner_passport',
  //   name: 'Паспорт иностранца',
  //   items: [
  //     { doctype: 'foreigner_passport_main', name: 'Основной разворот' },
  //     { doctype: 'foreigner_passport_selfie', name: 'Ваше фото с паспортом' }
  //   ]
  // },

  // {
  //   docgroup: 'id_card',
  //   name: 'ID карта',
  //   items: [
  //     { doctype: 'id_card_front', name: 'Лицевая сторона' },
  //     { doctype: 'id_card_back', name: 'Оборотная сторона' },
  //     { doctype: 'id_card_selfie', name: 'Ваше фото с ID картой' }
  //   ]
  // },

  // {
  //   docgroup: 'migration_card',
  //   name: 'Миграционная карта',
  //   items: [
  //     { doctype: 'migration_card_front', name: 'Лицевая сторона' },
  //     { doctype: 'migration_card_back', name: 'Оборотная сторона' },
  //     { doctype: 'migration_card_additional', name: 'Дополнительные страницы' }
  //   ]
  // },

  // {
  //   docgroup: 'resident_registration',
  //   name: 'Регистрация по месту жительства',
  //   items: [
  //     { doctype: 'resident_registration_front', name: 'Лицевая сторона' },
  //     { doctype: 'resident_registration_back', name: 'Оборотная сторона' }
  //   ]
  // }
];
